<div class="mapa-calor">
    <div class="mapa-calor-card">
        <div class="mapa-calor-grafico">
            <canvas #mapaCalorCanvas></canvas>
        </div>
        <aside class="mapa-calor-legenda" aria-label="Legenda por UF">
            <header class="mapa-calor-legenda-header">
                <span class="mapa-calor-legenda-titulo">Médicos ativos por UF</span>
                <span class="mapa-calor-legenda-subtitulo">Ordenado por maior total</span>
            </header>
            <div class="mapa-calor-legenda-lista">
                @for (item of legendaMedicos; track item.uf) {
                    <div class="mapa-calor-legenda-item">
                        <span class="mapa-calor-legenda-uf">{{ item.uf }}</span>
                        <span class="mapa-calor-legenda-nome">{{ item.nome }}</span>
                        <span class="mapa-calor-legenda-total">{{ item.total | number: '1.0-0' }}</span>
                    </div>
                }
            </div>
        </aside>
    </div>
</div>
